import { useSyncExternalStore } from 'react'

/* ===========================================================================
 *  Waar je bent
 *
 *  Het adres IS de stand, zoals bij Exact: een factuur is een link die je
 *  kunt doorsturen, en de terugknop van de telefoon (of de veeg vanaf de
 *  rand) doet wat je verwacht. Geen bibliotheek: vijf schermen diep is een
 *  pushState en een popstate.
 *
 *  `diepte` in history.state telt hoe ver je binnen deze app bent. Op 0
 *  (je kwam via een link rechtstreeks op een factuur) gaat "terug" naar het
 *  scherm erboven in plaats van de app uit.
 * =========================================================================== */

type Luisteraar = () => void
const luisteraars = new Set<Luisteraar>()

function meld() { for (const l of luisteraars) l() }

if (typeof window !== 'undefined') window.addEventListener('popstate', meld)

function diepte(): number {
  const d = (history.state as { diepte?: number } | null)?.diepte
  return typeof d === 'number' ? d : 0
}

export function ga(pad: string, vervang = false) {
  if (pad === location.pathname + location.search) return
  if (vervang) history.replaceState({ diepte: diepte() }, '', pad)
  else history.pushState({ diepte: diepte() + 1 }, '', pad)
  window.scrollTo(0, 0)
  meld()
}

/** Terug, of naar `ouder` als er binnen de app niets is om naar terug te gaan. */
export function terug(ouder = '/') {
  if (diepte() > 0) history.back()
  else ga(ouder, true)
}

export function usePad(): string {
  return useSyncExternalStore(
    (l) => { luisteraars.add(l); return () => { luisteraars.delete(l) } },
    () => location.pathname,
  )
}

export function useZoekParam(naam: string): string | null {
  const zoek = useSyncExternalStore(
    (l) => { luisteraars.add(l); return () => { luisteraars.delete(l) } },
    () => location.search,
  )
  return new URLSearchParams(zoek).get(naam)
}
